<template>
  <div
    class="venn-wrap position-absolute"
    :class="{ 'active': active }"
    :style="[ { opacity: Math.max(0.3, opacity) }, isSmall ? { width: (scaleMax * 100 / 375) + 'vw' } : {} ]"
  >
    <svg
      class="venn-vector"
      :style="{ transform: isSmall ? 'translateX(' + transDir + (((maxR * scale) / 2) * 0.75) + 'px)' : 'translateX(' + transDir + (100 / maxR) + '%)' }"
      :viewBox="isSmall ? '0 0 ' + scaleMax + ' ' + scaleMax : '0 0 ' + (maxR * 2) + ' ' + (maxR * 2)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient :id="'active' + uuid" gradientTransform="rotate(75 0.5 0.5)">
          <stop offset="0%" :stop-color="activeGrad[0]"/>
          <stop offset="100%" :stop-color="activeGrad[1]"/>
        </linearGradient>
        <linearGradient :id="'inactive' + uuid" gradientTransform="rotate(-45 0.5 0.5)">
          <stop offset="0%" :stop-color="inactiveGrad[0]"/>
          <stop offset="100%" :stop-color="inactiveGrad[1]"/>
        </linearGradient>
        <filter :id="uuid + 'blur'">
          <feGaussianBlur in="SourceGraphic" :stdDeviation="blur"/>
        </filter>
      </defs>

      <g :filter="active ? '' : 'url(#' + uuid + 'blur)'">
        <circle :transform="'matrix(' + scale + ' 0 0 ' + scale + ' ' + scaleTrans + ' ' + scaleTrans + ')'" :cx="maxR"
                :cy="maxR" :r="maxR" :fill="'url(#inactive' + uuid + ')'" :opacity="Math.abs(opacity - 1)"/>
        <circle :transform="'matrix(' + scale + ' 0 0 ' + scale + ' ' + scaleTrans + ' ' + scaleTrans + ')'" :cx="maxR"
                :cy="maxR" :r="maxR" :fill="'url(#active' + uuid + ')'" :opacity="opacity"/>
        <percent-vect
          :text-color="active ? '#FFFFFF' : accent"
          :font-size="textSize"
          :font-size-max="textSizeMax"
          :num="Math.ceil(percentNum)"
          :align="label.align"
          :pos="label.pos"
          :label="label.title"
          :center="maxR"
          :ind-override="indOverride"
          :activated="activated"
        />
      </g>
    </svg>
  </div>
</template>

<script>
  import { TweenMax, Power1 } from 'gsap'
  import { dataTransTime } from '@/lib/consts'
  import { gradPtColor } from '@/lib/funcs'
  import GraphFragMixin from '@/components/report/mixins/GraphFragMixin'
  import PercentVect from '@/components/svg/PercentVect'

  export default {
    name: 'VennFragment',
    mixins: [ GraphFragMixin ],
    props: { numActive: Boolean, pos: Object },
    data () {
      return {
        percentNum: this.numActive ? this.target : 0,
        blur: this.active ? 0 : 5,
        opacity: this.active ? 1 : 0,
        scaleMax: 230,
        scaleMin: 105,
        textSize: 0,
        activated: false
      }
    },
    computed: {
      maxR () { return this.isSmall ? this.scaleMax / 2 : 175 },

      scaledSize () { return ((this.percentNum / 100) * (this.scaleMax - this.scaleMin)) + this.scaleMin },

      scale () { return this.isSmall ? this.scaledSize / this.scaleMax : this.scaledSize / this.scaleMax },

      textSizeMax () { return this.isSmall ? 96 : 124 },

      scaleTrans () { return this.maxR - this.scale * this.maxR },

      transDir () { return this.pos.x === 'left' ? '-' : '' },

      activeGrad () { return [ gradPtColor( ...this.colors, 0 ), gradPtColor( ...this.colors, 0.35 ) ] },

      inactiveGrad () {
        return [ gradPtColor( this.mainColor, '#000000', 0.15 ), gradPtColor( this.mainColor, '#000000', 0.8 ) ]
      },

      scaledFontSize () {
        let size = this.textSizeMax
        if (this.percentNum < 45) {
          size = Math.ceil(this.textSizeMax * 0.58)
        } else if (this.percentNum < 70) {
          size = Math.ceil(this.textSizeMax * 0.75)
        }
        return size
      }
    },
    watch: {
      active ( val ) {
        TweenMax.to( this, dataTransTime / 4, { blur: val ? 0 : 5, opacity: val ? 1 : 0.3 } )
      },
      numActive ( val ) {
        let time = dataTransTime * 0.8
        let triggerTime = time * 0.85
        let tween = TweenMax.to( this, time, {
          percentNum: val ? this.target : 0,
          textSize: val ? this.textSizeMax : 0,
          ease: Power1.easeInOut,
          onUpdate: () => {
            if ( tween.time() > triggerTime ) {
              this.$emit( 'activated' )
              this.activated = true
            }
          }
        } )
      },
      target ( val ) {
        this.handleChange( val, dataTransTime / 4, 'percentNum' )
      },
      scaledFontSize ( val ) {
        TweenMax.to( this, dataTransTime / 6, { textSize: val } )
      }
    },
    components: { PercentVect }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/content/VennFragment.vue